module.exports = __webpack_public_path__ + "static/media/Slide09.03520007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide09.png
// module id = 1631
// module chunks = 0